import { render, staticRenderFns } from "./simulationBanner.vue?vue&type=template&id=397f8d16&scoped=true&"
import script from "./simulationBanner.vue?vue&type=script&lang=js&"
export * from "./simulationBanner.vue?vue&type=script&lang=js&"
import style0 from "./simulationBanner.vue?vue&type=style&index=0&id=397f8d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397f8d16",
  null
  
)

export default component.exports